<div class="child-container">
  <h2 class="title">Add Child Companies</h2>

  <div class="controls no-wrap">
    <!-- Parent Identity Dropdown -->
    <select
      class="dropdown"
      [(ngModel)]="parentIdentity"
      (change)="onParentChange()"
    >
      <option value="">Parent Identity</option>
      <option *ngFor="let parent of parentOptions" [value]="parent">
        {{ parent }}
      </option>
    </select>

    <!-- Child Identity Dropdown -->
    <select
      class="dropdown"
      [(ngModel)]="childIdentity"
      [disabled]="!childOptions.length"
    >
      <option value="">Child Identity</option>
      <option *ngFor="let child of childOptions" [value]="child">
        {{ child }}
      </option>
    </select>

    <!-- Group Name Input -->
    <div>
      <input
        type="text"
        class="input"
        id="groupName"
        [(ngModel)]="groupName"
        placeholder="Group Name"
        required
      />
    </div>

    <!-- Search Organization -->
    <div class="dropdown-wrapper">
      <input
        id="companySearch"
        type="text"
        [(ngModel)]="companySearch"
        (focus)="showSuggestions = true"
        (input)="filterOrganizations()"
        class="dropdown-input"
        placeholder="Search organization..."
        (blur)="hideSuggestions()"
        autocomplete="off"
      />

      <div *ngIf="showSuggestions" class="dropdown-panel scrollable">
        <ul class="dropdown-list">
          <li
            *ngFor="let org of filteredOrganizations"
            (mousedown)="selectOrganization(org.organization_name)"
            class="dropdown-item"
          >
            {{ org.organization_name }}
          </li>
          <li *ngIf="filteredOrganizations.length === 0" class="no-results">
            No matching results
          </li>
        </ul>
      </div>
    </div>

    <!-- Add Child Button -->
    <button class="add-child" (click)="addChild()">Add child</button>
    <!-- Back Button -->
  <button class="back-btn" (click)="goBack()">Back</button>
  </div>

  

  <!-- Removed legacy toast div handled by ngx-toastr -->

  <!-- Child Table -->
  <table class="child-table">
    <thead>
      <tr>
        <th>Parent Identity</th>
        <th>Child Identity</th>
        <th>Group Name</th>
        <th>Child Name</th>
        <th>Remove</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let child of paginatedChildren">
        <td>{{ child.parent_identity }}</td>
        <td>{{ child.child_identity }}</td>
        <td>{{ child.group_name }}</td>
        <td>{{ getChildName(child.child_company_id) }}</td>
        <td>
<span class="remove" (click)="removeChild(child)">–</span>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Pagination -->
  <div class="pagination-container">
    <button
      (click)="changePage(currentPage - 1)"
      [disabled]="currentPage === 1"
    >
      Prev
    </button>
    <ng-container
      *ngFor="let page of [].constructor(totalPages); let i = index"
    >
      <button
        [class.active]="currentPage === i + 1"
        (click)="changePage(i + 1)"
      >
        {{ i + 1 }}
      </button>
    </ng-container>
    <button
      (click)="changePage(currentPage + 1)"
      [disabled]="currentPage === totalPages"
    >
      Next
    </button>
  </div>
</div>


<div class="modal-overlay" *ngIf="showDeleteModal">
  <div class="modal-box">
    <p class="modal-message">{{ confirmMessage }}</p>
    <div class="modal-actions">
      <button class="modal-btn confirm" (click)="confirmDelete()">Yes</button>
      <button class="modal-btn cancel" (click)="closeModal()">No</button>
    </div>
  </div>
</div>


